'use strict';

var React = require('react');
var CompositeIconBase = require('../common/CompositeIconBase');
var IconButton2 = React.createClass({
  render: function () {
    return (<CompositeIconBase
      {...this.props}
      borderVisible={true}
      alarmVisible={this.props.showAlarm}
      iconVisible={true}
      labelVisible={this.props.showText}>
      {
        this.props.children
      }
    </CompositeIconBase>);
  }
});

module.exports = IconButton2;


// WEBPACK FOOTER //
// ./src/views/Components/IconButton2.jsx